import Endpoints from 'constants/Endpoints';
import {RestRequestGET} from 'libs/RestRequest';

const getRequired = async () => {
    return await _get();
};

const getWithEmptyOption = async () => {
    const list = await _get();
    return [{label: '---', value: ''}, ...list];
};

const _get = async () => {
    try {
        const resp = await RestRequestGET(Endpoints.MEASURE_UNITS);
        resp.sort((a, b) => a.label.localeCompare(b.label));
        return resp;
    } catch (error) {
    }
};


export default {
    getRequired, getWithEmptyOption
}